/* ==========================================================================
   Blanket Statement — size guide

   Drives both the homepage section and the pop-up on the product page. One
   scale governs the bed and the blanket, so a blanket larger than the bed makes
   the bed shrink rather than overflowing the stage.
   ========================================================================== */
(function () {
  'use strict';

  var BED_W = 60, BED_H = 80;      // a queen bed, in inches

  function init(root) {
    if (!root || root.__sg) return;
    root.__sg = true;

    var stage   = root.querySelector('[data-sg-stage]');
    var bed     = root.querySelector('[data-sg-bed]');
    var overlay = root.querySelector('[data-sg-overlay]');
    var caption = root.querySelector('[data-sg-caption]');
    var rows    = root.querySelectorAll('[data-sg-row]');
    var orients = root.querySelectorAll('[data-sg-orient]');
    if (!stage || !overlay || !rows.length) return;

    var orientation = 'landscape';
    var current = null;

    function dims(row) {
      var w = parseFloat(row.dataset.w), h = parseFloat(row.dataset.h);
      if (w === h) return { w: w, h: h };            // a square has no orientation
      var lo = Math.min(w, h), hi = Math.max(w, h);
      return orientation === 'portrait' ? { w: lo, h: hi } : { w: hi, h: lo };
    }

    function paint() {
      if (!current) return;
      var d = dims(current);
      var box = stage.getBoundingClientRect();
      var pad = 64;
      var availW = Math.max(120, box.width  - pad);
      var availH = Math.max(120, box.height - pad);
      var ppi = Math.min(availW / Math.max(BED_W, d.w), availH / Math.max(BED_H, d.h));

      if (bed) { bed.style.width = (BED_W * ppi) + 'px'; bed.style.height = (BED_H * ppi) + 'px'; }
      overlay.style.width  = (d.w * ppi) + 'px';
      overlay.style.height = (d.h * ppi) + 'px';
      if (caption) caption.innerHTML = d.w + '&quot; &times; ' + d.h + '&quot;';
    }

    function select(row) {
      current = row;
      rows.forEach(function (r) { r.setAttribute('aria-pressed', String(r === row)); });
      paint();
    }

    rows.forEach(function (r) { r.addEventListener('click', function () { select(r); }); });
    orients.forEach(function (b) {
      b.addEventListener('click', function () {
        orientation = b.dataset.sgOrient;
        orients.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        paint();
      });
    });

    var start = root.querySelector('[data-sg-row][data-sg-default]') || rows[Math.min(2, rows.length - 1)];
    select(start);

    if (window.ResizeObserver) new ResizeObserver(paint).observe(stage);
    root.__sgPaint = paint;
  }

  /* ---- Pop-up ---------------------------------------------------------- */

  function bindModal() {
    document.querySelectorAll('[data-sg-open]').forEach(function (btn) {
      if (btn.__bound) return;
      btn.__bound = true;
      var modal = document.getElementById(btn.getAttribute('data-sg-open'));
      if (!modal) return;
      var panel = modal.querySelector('.bs-sg-modal__panel');
      var lastFocus = null;

      function open() {
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        // The stage has no size until it is visible, so measure after painting.
        requestAnimationFrame(function () {
          var g = modal.querySelector('[data-bs-size-guide]');
          init(g);
          if (g && g.__sgPaint) g.__sgPaint();
          var close = modal.querySelector('[data-sg-close]');
          if (close) close.focus();
        });
      }
      function close() {
        modal.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      }

      btn.addEventListener('click', open);
      modal.querySelectorAll('[data-sg-close]').forEach(function (c) {
        c.addEventListener('click', close);
      });
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
      // Keep focus inside the panel while it is open.
      modal.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || modal.hidden) return;
        var f = panel.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-bs-size-guide]').forEach(function (g) {
      if (!g.closest('.bs-sg-modal')) init(g);   // inline ones start now
    });
    bindModal();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
